import React, { useState } from 'react';
import { TextField, Button, Typography, Alert } from '@mui/material';
import axios from 'axios';
import LoginLayout from '../../commun/LoginLayout';
import { useNavigate } from 'react-router-dom';
import './auth.css';

const ForgotPassword = () => {
  const [email, setEmail]   = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE}/api/auth/forgot-password`, { email });
      setMessage({
        type: 'success',
        text: 'Un lien de réinitialisation a été envoyé par email.',
      });
      setTimeout(() => navigate('/login'), 5000);
    } catch (err) {
      setMessage({
        type: 'error',
        text: err.response?.data?.message || 'Erreur, veuillez réessayer.',
      });
    }
  };

  return (
    <LoginLayout>
      <Typography variant="h5" align="center" gutterBottom>
        Mot de passe oublié ?
      </Typography>
      <Typography variant="body2" align="center" className="mb-2">
        Entrez votre adresse email pour recevoir un lien de réinitialisation.
      </Typography>

      {message.text && (
        <Alert severity={message.type} className="mb-2">{message.text}</Alert>
      )}

      <form onSubmit={handleSubmit}>
        <TextField
          label="Adresse email"
          type="email"
          fullWidth
          required
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="mb-3"
        />
        <Button type="submit" variant="contained" fullWidth>
          Envoyer
        </Button>
      </form>
    </LoginLayout>
  );
};

export default ForgotPassword;
